import React, { Component } from 'react';
import './Customerheader.scss';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import companylogo from '../../../assets/images/companylogo.svg';
import IconButton from '@material-ui/core/IconButton';
import InputBase from '@material-ui/core/InputBase';
import searchicon from '../../../assets/images/searchicon.svg';
import MenuItem from '@material-ui/core/MenuItem';
import plusicon from '../../../assets/images/plusicon.svg';
import cardviewgreen from '../../../assets/images/cardviewgreen.svg';
import cardtype from '../../../assets/images/cardtype.svg';
import InputLabel from '@material-ui/core/InputLabel';
import { withRouter } from "react-router-dom";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Customdaterange from '../../modals/customdaterange/customdaterange';
import CollectionFiltersButton from '../../CollectionReports/CollectionFiltersButtons/CollectionFiltersButtons';
import Select from '@material-ui/core/Select';
import { BaseUrl } from "../../../Environment";
import moment from 'moment';
import { withNamespaces } from 'react-i18next';
import { getSecureItem } from '../../../utilsFunctions';

const axios = require('axios');

class CustomerHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      time: "Any time",
      filter: "Filters",
      AllCustomer: null,
      dueCustomer: "",
      overdueCustomer: "",
      filterCustomer: "",
      allText: "",
      dueText: "",
      overdueText: "",
      overduebackground: "",
      duebackground: "",
      allbackground: "",
      closeText: "",
      openText: "",
      newText: "",
      overdueWeight: "",
      dueWeight: "",
      allWeight: "",
      closeWeight: "",
      newWeight: "",
      openWeight: "",
      SelectedtimeColour: "#00D95E",
      SelectedColour: "#00D95E",
      allbuttns: "",
      allbuttnscard: "",
      cardgreen: "",
      cardd: "",
      listgreen: "",
      listt: "",
      subbuttn: "",
      subbuttncard: "",
      list: "",
      card: "",
      Openloans: [],
      Allloans: [],
      Closeloans: [],
      Dueloans: [],
      Overdueloans: [],
      Cancelloans: [],
      LaonType: [],
      branchId: null,
      branches: [],
      loanTypeDivision: "none",
      open: false,
      opendate: false,
      openprofile: false,
      openrange: false,
      loanTypeId: null,
      rangefrom: null,
      rangeto: null,
      openmodal: false,
      startdate: null,
      enddate: null,
      sequence: null,
      collectionseq: "",
      clearaction: {},
      loanPaymentStatus: null,
      loanStatus: "Open",
      label: "",
      cAgentDatas: [],
      cAgentId: "All",
      cAgentName: "",
      sortBy: "name",
      sortOrder: "asc",
      counts: {},
      searchValue: "",
      searchSuggestions: [],
      showSuggestions: false,
    };
    this.closemodal = this.closemodal.bind(this);
    this._suppressPageEffect = false;
  }

  getHeaders = () => ({
    Authorization: 'Bearer ' + getSecureItem('token'),
  });

  buildLoanPayload = (overrides = {}) => {
    const loggedinUser = getSecureItem('loggedinUser');
    return {
      loanTypeId: this.state.loanTypeId,
      branchId: parseInt(this.state.branchId) || loggedinUser.branchId || null,
      page: this.props.currentPage || 1,
      pageSize: this.props.pageSize || 100,
      loanAmountFrom: this.state.rangefrom,
      loanAmountTo: this.state.rangeto,
      fromDate: this.state.startdate
        ? moment(this.state.startdate).format('YYYY-MM-DD HH:mm:ss')
        : null,
      toDate: this.state.enddate
        ? moment(this.state.enddate).format('YYYY-MM-DD HH:mm:ss')
        : null,
      loanTenureType: this.state.sequence,
      companyId: loggedinUser.companyId,
      collectorId: this.state.cAgentId !== 'All' ? this.state.cAgentId : null,
      sortBy: this.state.sortBy,
      sortOrder: this.state.sortOrder,
      ...overrides,
    };
  };

  fetchLoans = (payloadOverrides, callback) => {
    const payload = this.buildLoanPayload(payloadOverrides);
    axios
      .post(BaseUrl + '/loan/getAllLoans', payload, { headers: this.getHeaders() })
      .then((resp) => callback(resp.data));
  };

  dispatchCurrentView = (data, counts = {}, meta = {}) => {
    const { loanStatus, loanPaymentStatus } = this.state;
    const page = meta.page || this.props.currentPage || 1;
    const pageSize = meta.pageSize || this.props.pageSize || 10;
    const totalRecords = meta.totalRecords ?? data?.length ?? 0;
    const totalPages =
      meta.totalPages || Math.max(1, Math.ceil(totalRecords / pageSize));

    this.setState({ Allloans: data, counts, totalPages, totalRecords });
    if (loanStatus === 'Closed') {
      this.setState({ Closeloans: data });
      this.props.CloseView({ data, counts, page, pageSize, totalPages, totalRecords });
    } else if (loanStatus === 'Cancelled') {
      this.setState({ Cancelloans: data });
      this.props.CancelView({ data, counts, page, pageSize, totalPages, totalRecords });
    } else if (loanPaymentStatus === 'Due') {
      this.setState({ Dueloans: data });
      this.props.DueView({ data, counts, page, pageSize, totalPages, totalRecords });
    } else if (loanPaymentStatus === 'OverDue') {
      this.setState({ Overdueloans: data });
      this.props.OverdueView({ data, counts, page, pageSize, totalPages, totalRecords });
    } else {
      this.setState({ Openloans: data });
      this.props.OpenView({ data, counts, page, pageSize, totalPages, totalRecords });
      this.props.AllView({ data, loading: false, counts, page, pageSize, totalPages, totalRecords });
    }
  };

  fetchCurrentTab = (extraOverrides = {}) => {
    const { loanStatus, loanPaymentStatus } = this.state;
    this.fetchLoans(
      { loanStatus, loanPaymentStatus, ...extraOverrides },
      (resp) => this.dispatchCurrentView(resp.data, resp.counts || {}, resp)
    );
  };

  fetchTabPageOne = (statusOverrides) => {
    this.fetchLoans(
      { ...statusOverrides, page: 1 },
      (resp) => this.dispatchCurrentView(resp.data, resp.counts || {}, { ...resp, page: 1 })
    );
  };

  setLoanStatusNav = (loanStatus, loanPaymentStatus = null) => {
    const isOpen = loanStatus === 'Open';
    const isClosed = loanStatus === 'Closed';
    const isCancelled = loanStatus === 'Cancelled';
    this.setState({
      AllCustomer: isOpen ? 'initial' : 'none',
      dueCustomer: isOpen ? 'initial' : 'none',
      overdueCustomer: isOpen ? 'initial' : 'none',
      filterCustomer: isOpen ? 'initial' : (isCancelled ? 'none' : ''),
      collectionseq: isOpen ? 'contents' : 'none',
      closeText: isClosed ? '#4D66F0' : '#D4D4D5',
      openText: isOpen ? '#4D66F0' : '#D4D4D5',
      newText: isCancelled ? '#4D66F0' : '#D4D4D5',
      closeWeight: isClosed ? '900' : '',
      openWeight: isOpen ? '900' : '',
      newWeight: isCancelled ? '900' : '',
      loanPaymentStatus,
      loanStatus,
    });
  };

  setPaymentStatusNav = (paymentStatus) => {
    const isAll = paymentStatus === null;
    const isDue = paymentStatus === 'Due';
    const isOverdue = paymentStatus === 'OverDue';
    this.setState({
      allText: isAll ? '#3E4664' : '#757575',
      dueText: isDue ? '#3E4664' : '#757575',
      overdueText: isOverdue ? '#3E4664' : '#757575',
      allbackground: isAll ? '#E8E9EF' : '',
      duebackground: isDue ? '#E8E9EF' : '',
      overduebackground: isOverdue ? '#E8E9EF' : '',
      allWeight: isAll ? '900' : '',
      dueWeight: isDue ? '900' : '',
      overdueWeight: isOverdue ? '900' : '',
      loanPaymentStatus: paymentStatus,
    });
  };

  resetPage = () => {
    if (this.props.onPageChange) {
      this._suppressPageEffect = true;
      this.props.onPageChange(1);
    }
  };

  opencustomer() {
    this.resetPage();
    this.props.history.push('/customer');
    this.setLoanStatusNav('Open');
    this.fetchTabPageOne({ loanStatus: 'Open', loanPaymentStatus: null });
  }
  opencustomerlist() { this.opencustomer(); }

  closedcustomer() {
    this.resetPage();
    this.props.history.push('/customer/closedcustomer');
    this.setLoanStatusNav('Closed');
    this.fetchTabPageOne({ loanStatus: ['Closed', 'Replaned'], loanPaymentStatus: undefined });
  }
  closedcustomerlist() { this.closedcustomer(); }

  newcustomer() {
    this.resetPage();
    this.props.history.push({ pathname: '/customer/newcustomer', params: this.state.list });
    this.setLoanStatusNav('Cancelled');
    this.fetchTabPageOne({ loanStatus: 'Cancelled', loanPaymentStatus: null });
  }
  newcustomerlist() {
    this.props.history.push('/customer/newcustomer');
    this.setLoanStatusNav('Cancelled');
    this.fetchTabPageOne({ loanStatus: 'Cancelled', loanPaymentStatus: null });
  }

  allcustomer() {
    this.resetPage();
    this.props.history.push('/customer');
    this.setPaymentStatusNav(null);
    this.setState({ loanStatus: 'Open' }, () =>
      this.fetchTabPageOne({ loanStatus: 'Open', loanPaymentStatus: null })
    );
  }
  allcustomerlist() { this.allcustomer(); }

  duecustomer() {
    this.resetPage();
    this.props.history.push('/customer/duecustomer');
    this.setPaymentStatusNav('Due');
    this.setState({ loanStatus: 'Open' }, () =>
      this.fetchTabPageOne({ loanStatus: 'Open', loanPaymentStatus: 'Due' })
    );
  }
  duecustomerlist() { this.duecustomer(); }

  overduecustomer() {
    this.resetPage();
    this.props.history.push('/customer/overduecustomer');
    this.setPaymentStatusNav('OverDue');
    this.setState({ loanStatus: 'Open' }, () =>
      this.fetchTabPageOne({ loanStatus: 'Open', loanPaymentStatus: 'OverDue' })
    );
  }
  overduecustomerlist() { this.overduecustomer(); }

  getAllCA = async () => {
    const loggedinUser = getSecureItem('loggedinUser');
    axios
      .get(
        `${BaseUrl}/user/getAllUsers?userName=&companyId=${loggedinUser?.companyId}`,
        { headers: this.getHeaders() }
      )
      .then((response) => this.setState({ cAgentDatas: response.data?.result }))
      .catch((error) => console.log({ error }));
  };

  addcustomer() { this.props.history.push('/addloannointerest'); }
  addLoanImport() { this.props.history.push('/loan/loanCsvImport'); }

  componentDidUpdate(prevProps) {
    if (prevProps?.location.pathname !== this.props?.location.pathname) {
      this.setState({ cAgentId: 'All', cAgentName: '', cAgentDatas: [] });
      this.getAllCA();
      this.applyTabFromPath(this.props.location.pathname);
    }

    if (prevProps?.currentPage !== this.props?.currentPage || prevProps?.pageSize !== this.props?.pageSize) {
      if (this._suppressPageEffect) {
        this._suppressPageEffect = false;
      } else {
        this.fetchCurrentTab();
      }
    }
  }

  deriveTabFromPath = (path) => {
    let loanStatus = 'Open';
    let loanPaymentStatus = null;

    if (path === '/customer/duecustomer') {
      loanPaymentStatus = 'Due';
    } else if (path === '/customer/overduecustomer') {
      loanPaymentStatus = 'OverDue';
    } else if (path === '/customer/closedcustomer') {
      loanStatus = 'Closed';
    } else if (path === '/customer/newcustomer') {
      loanStatus = 'Cancelled';
    }
    return { loanStatus, loanPaymentStatus };
  };

  applyTabFromPath = (path) => {
    const { loanStatus, loanPaymentStatus } = this.deriveTabFromPath(path);
    this.setLoanStatusNav(loanStatus, loanPaymentStatus);
    this.setPaymentStatusNav(loanPaymentStatus);
    this.fetchCurrentTab({ loanStatus, loanPaymentStatus });
  };

  async componentDidMount() {
    this.getAllCA();
    this.setState({
      allCustomer: "initial",
      dueCustomer: "initial",
      overdueCustomer: "initial",
      filterCustomer: "initial",
      collectionseq: "contents",
      allbuttns: "none",
      cardgreen: "",
      cardd: "none",
      listgreen: "none",
      listt: "",
      subbuttn: "none",
      subbuttncard: "",
      allbuttnscard: "",
    });

    this.applyTabFromPath(this.props.location.pathname);

    this.AllLoanTypeList();
    await this.fetchBranches();
  }

  handleChangetime = (event) => {
    this.setState({ time: event.target.value, SelectedtimeColour: '#00D95E' });
  };

  handleChangefilter = (event) => {
    this.setState({ filter: event.target.value, SelectedColour: '#00D95E' });
    if (event.target.value === 'Loan type') {
      this.setState({ loanTypeDivision: '' });
    }
  };

  CardType(card) {
    this.setState({
      allbuttns: 'none', cardgreen: '', cardd: 'none',
      listgreen: 'none', listt: '', subbuttn: 'none',
      subbuttncard: '', allbuttnscard: '', card,
    });
    this.props.cardView();
  }

  ListType(list) {
    this.setState({
      allbuttns: '', cardgreen: 'none', cardd: '',
      listgreen: '', listt: 'none', subbuttn: '',
      subbuttncard: 'none', allbuttnscard: 'none', list,
    });
    this.props.listView();
  }

  AllLoanTypeList() {
    const loggedinUser = getSecureItem('loggedinUserCompany');
    axios
      .get(
        BaseUrl + '/loanType/getAllLoanTypes?loanType=&companyId=' + loggedinUser,
        { headers: this.getHeaders() }
      )
      .then((resp) => {
        if (resp.status === 200) {
          this.modifyJsonFormat(resp.data);
        } else {
          toast.error('Something went wrong. Please try again later!', {
            position: 'top-center', autoClose: 2000, hideProgressBar: true,
            closeOnClick: true, pauseOnHover: false, draggable: true,
          });
        }
      })
      .catch((err) => console.log({ err }));
  }

  fetchBranches = async () => {
    try {
      const token = getSecureItem("token");
      const headers = {
        Authorization: "Bearer " + token,
      };
      const loggedinUser = getSecureItem("loggedinUser");

      const { data } = await axios.get(`${BaseUrl}/branch/getAllBranches`, {
        params: { companyId: loggedinUser?.companyId },
        headers,
      });

      const branchData = loggedinUser?.userType == "superAdmin" ? data?.data : data?.data?.filter((item) => item?.branchId == loggedinUser?.branchId);

      const branches = branchData?.map(item => ({
        value: item.branchId,
        label: item.branchName,
        isActive: false
      })) || [];

      this.setState({ branches });
    } catch (err) {
      console.error("Fetch Branches Error:", err);
    }
  };

  modifyJsonFormat = (data) => {
    const modData = data.map((obj) => ({ loanTypeId: obj.loanTypeId, label: obj.loanType }));
    this.setState({ LaonType: modData });
  };

  handleClick = () => { this.setState({ open: true }); };
  handleClose = () => { this.setState({ open: false, openprofile: false }); };
  handleClosedate = () => { this.setState({ opendate: false }); };

  Filter = (range) => {
    this.resetPage();
    if (range.subMenuClear === true && range.menuID === undefined) {
      this.setState(
        { loanTypeId: null, branchId: null, rangefrom: null, rangeto: null, startdate: null, enddate: null },
        () => this.fetchTabPageOne(this.currentTabOverrides())
      );
      return;
    }

    let newLoanTypeId = this.state.loanTypeId;
    let newBranchId = parseInt(this.state.branchId) || null;
    let newRangeFrom = this.state.rangefrom;
    let newRangeTo = this.state.rangeto;

    if (range.menuID === '2') {
      if (range.subMenuActive) {
        const words = range.subMenuID.split('-');
        newRangeFrom = words[0];
        newRangeTo = words[1];
      } else {
        newRangeFrom = null;
        newRangeTo = null;
      }
    } else if (range.menuID === '1') {
      newLoanTypeId = range.subMenuActive ? range.subMenuID : null;
    } else if (range.menuID === 'branch') {
      newBranchId = range.subMenuActive ? parseInt(range.subMenuID) : null;
    }

    this.setState(
      { loanTypeId: newLoanTypeId, branchId: newBranchId, rangefrom: newRangeFrom, rangeto: newRangeTo },
      () => this.fetchTabPageOne(this.currentTabOverrides())
    );
  };

  currentTabOverrides = () => {
    const { loanStatus, loanPaymentStatus } = this.state;
    if (loanStatus === 'Closed') {
      return { loanStatus: ['Closed', 'Replaned'], loanPaymentStatus: undefined };
    }
    return { loanStatus, loanPaymentStatus };
  };

  save = (obj) => {
    this.resetPage();
    this.setState(
      { startdate: obj.start || null, enddate: obj.end || null },
      () => this.fetchTabPageOne(this.currentTabOverrides())
    );
  };

  searchTimeout = null;

  handleSearchInputChange = (event) => {
    const value = event.target.value;

    this.setState({
      searchValue: value,
      showSuggestions: false,
    });

    if (!value.trim()) {
      this.setState({
        searchSuggestions: [],
        showSuggestions: false,
      });
      this.resetPage();
      this.fetchTabPageOne(this.currentTabOverrides());
    }
  };

  handleSearch = () => {
    const { searchValue } = this.state;

    if (!searchValue.trim()) {
      this.setState({
        searchSuggestions: [],
        showSuggestions: false,
      });
      this.resetPage();
      this.fetchTabPageOne(this.currentTabOverrides());
      return;
    }

    this.fetchSearchSuggestions(searchValue);
  };

  fetchSearchSuggestions = (search) => {
    const loggedinUser = getSecureItem('loggedinUser');
    axios
      .get(`${BaseUrl}/loan/searchSuggestions`, {
        params: { search, companyId: loggedinUser?.companyId },
        headers: this.getHeaders(),
      })
      .then((resp) => {
        this.setState({ searchSuggestions: resp.data?.data || [], showSuggestions: true });
      })
      .catch((err) => console.log({ err }));
  };

  selectSuggestion = (customer) => {
    this.setState(
      { searchValue: `${customer.firstName} ${customer.lastName}`, showSuggestions: false, searchSuggestions: [] },
      () => {
        this.resetPage();
        const { loanStatus, loanPaymentStatus } = this.state;
        this.fetchLoans(
          {
            customerId: customer.customerId,
            loanStatus,
            loanPaymentStatus: (loanStatus === 'Closed' || loanStatus === 'Cancelled') ? null : loanPaymentStatus,
            page: 1,
          },
          (resp) => {
            this.dispatchCurrentView(resp.data, resp.counts || {}, { ...resp, page: 1 });
          }
        );
      }
    );
  };

  closeSuggestions = () => {
    setTimeout(() => this.setState({ showSuggestions: false }), 150);
  };

  componentWillUnmount() {
    if (this.searchTimeout) clearTimeout(this.searchTimeout);
  }

  CollectseqChange = (event) => {
    this.resetPage();
    const seq = event.target.value || null;
    this.setState(
      { sequence: seq, label: seq ? 'none' : 'initial' },
      () => this.fetchTabPageOne(this.currentTabOverrides())
    );
  };

  CollectionAgentChange = (event) => {
    this.resetPage();
    const agentId = event.target.value;
    this.setState({ cAgentId: agentId }, () => this.fetchTabPageOne(this.currentTabOverrides()));
  };

  handledateClick = (event) => {
    this.setState({ opendate: true, anchorEl: event.currentTarget });
  };

  clearDate() {
    this.resetPage();
    this.setState(
      { fromDate: null, toDate: null, startdate: null, enddate: null, opendate: false },
      () => this.fetchTabPageOne(this.currentTabOverrides())
    );
  }

  updateSort = (sortBy, sortOrder) => {
    this.resetPage();
    this.setState({ sortBy, sortOrder }, () => this.fetchTabPageOne(this.currentTabOverrides()));
  };

  profileClick = () => { this.setState({ openprofile: true }); };
  rangeClick = () => { this.setState({ openrange: true }); };

  customdate() { this.setState({ openmodal: true, opendate: false }); }
  closemodal() { this.setState({ openmodal: false }); }

  handlechange = () => { };

  render() {
    const { t } = this.props;
    const counts = this.state.counts || {};
    const userPermissions = getSecureItem("UsersAccess");

    return (
      <div>
        <div className="customerMainHeader">
          <section className='Customerheader'>
            <div className="twoRow">
              <Toolbar>
                <div className="customerHeaderWrapper">
                  <Typography variant="h6" className='title' component={'div'}>
                    <img src={companylogo} alt="logo" />
                  </Typography>
                  <div>
                    <div className="OptionDiv" style={{ display: this.state.allbuttnscard }}>
                      <div style={{ color: this.state.openText, fontWeight: this.state.openWeight }} onClick={this.opencustomer.bind(this)} className="option Fonts btnSizeFont">
                        <span>{t('Loans.open')}</span>{counts?.open > 0 && <span style={{ marginLeft: "5px" }}>({counts?.open})</span>}
                      </div>
                      <div style={{ color: this.state.closeText, fontWeight: this.state.closeWeight }} onClick={this.closedcustomer.bind(this)} className="option Fonts btnSizeFont">
                        <span>{t('Loans.close')}</span>{counts?.close > 0 && <span style={{ marginLeft: "5px" }}>({counts?.close})</span>}
                      </div>
                      <div style={{ color: this.state.newText, fontWeight: this.state.newWeight }} onClick={this.newcustomer.bind(this)} className="option Fonts btnSizeFont">
                        <span>{t('Loans.cancel')}</span>{counts?.cancel > 0 && <span style={{ marginLeft: "5px" }}>({counts?.cancel})</span>}
                      </div>
                    </div>
                    <div className="OptionDiv" style={{ display: this.state.allbuttns }}>
                      <div style={{ color: this.state.openText, fontWeight: this.state.openWeight }} onClick={this.opencustomerlist.bind(this)} className="option Fonts btnSizeFont">
                        <span>{t('Loans.open')}</span>{counts?.open > 0 && <span style={{ marginLeft: "5px" }}>({counts?.open})</span>}
                      </div>
                      <div style={{ color: this.state.closeText, fontWeight: this.state.closeWeight }} onClick={this.closedcustomerlist.bind(this)} className="option Fonts btnSizeFont">
                        <span>{t('Loans.close')}</span>{counts?.close > 0 && <span style={{ marginLeft: "5px" }}>({counts?.close})</span>}
                      </div>
                      <div style={{ color: this.state.newText, fontWeight: this.state.newWeight }} onClick={this.newcustomerlist.bind(this)} className="option Fonts btnSizeFont">
                        <span>{t('Loans.cancel')}</span>{counts?.cancel > 0 && <span style={{ marginLeft: "5px" }}>({counts?.cancel})</span>}
                      </div>
                    </div>
                  </div>
                  <div className="searchDiv" style={{ position: 'relative' }}>
                    <IconButton
                      className="iconButton"
                      aria-label="search"
                      onClick={this.handleSearch}
                    >
                      <img
                        src={searchicon}
                        alt="searchicon"
                        className="iconButton"
                      />
                    </IconButton>
                    <InputBase
                      className="input"
                      placeholder="Search Borrower"
                      value={this.state.searchValue}
                      onChange={this.handleSearchInputChange}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          this.handleSearch();
                        }
                      }}
                      onBlur={this.closeSuggestions}
                      onFocus={() => {
                        if (this.state.searchSuggestions.length > 0) {
                          this.setState({ showSuggestions: true });
                        }
                      }}
                    />
                    {this.state.showSuggestions && this.state.searchSuggestions.length > 0 && (
                      <ul className="customerSearchDropdown">
                        {this.state.searchSuggestions.map((customer) => (
                          <li
                            key={customer.customerId}
                            className="customerSearchDropdownItem"
                            onMouseDown={() => this.selectSuggestion(customer)}
                          >
                            <span>{customer.firstName} {customer.lastName}</span>
                            <span className="customerSearchDropdownSub">
                              {customer.cust_id}{customer.phone ? ` • ${customer.phone}` : ''}
                            </span>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
              </Toolbar>
            </div>
            <div className="paymentTabsDiv" style={{ display: this.state.AllCustomer }}>
              <Typography variant="h6" className='titleOne' style={{ display: this.state.subbuttncard }} component={'div'}>
                <Button variant="outlined" className="Tabbutton Fonts" style={{ color: this.state.allText, backgroundColor: this.state.allbackground, fontWeight: this.state.allWeight }} onClick={this.allcustomer.bind(this)}>
                  {t('Loans.all')}{counts?.open > 0 && <span style={{ marginLeft: "5px" }}>({counts?.open})</span>}
                </Button>
                <Button variant="outlined" className="Tabbutton Fonts" style={{ color: this.state.dueText, backgroundColor: this.state.duebackground, fontWeight: this.state.dueWeight }} onClick={this.duecustomer.bind(this)}>
                  {t('Loans.due')}{counts?.due > 0 && <span style={{ marginLeft: "5px" }}>({counts?.due})</span>}
                </Button>
                <Button variant="outlined" className="Tabbutton Fonts" style={{ color: this.state.overdueText, backgroundColor: this.state.overduebackground, fontWeight: this.state.overdueWeight }} onClick={this.overduecustomer.bind(this)}>
                  {t('Loans.over')}{counts?.overdue > 0 && <span style={{ marginLeft: "5px" }}>({counts?.overdue})</span>}
                </Button>
              </Typography>
              <Typography variant="h6" className='titleOne' style={{ display: this.state.subbuttn }}>
                <Button variant="outlined" className="Tabbutton Fonts" style={{ color: this.state.allText, backgroundColor: this.state.allbackground, fontWeight: this.state.allWeight }} onClick={this.allcustomerlist.bind(this)}>
                  {t('Loans.all')}{counts?.open > 0 && <span style={{ marginLeft: "5px" }}>({counts?.open})</span>}
                </Button>
                <Button variant="outlined" className="Tabbutton Fonts" style={{ color: this.state.dueText, backgroundColor: this.state.duebackground, fontWeight: this.state.dueWeight }} onClick={this.duecustomerlist.bind(this)}>
                  {t('Loans.due')}{counts?.due > 0 && <span style={{ marginLeft: "5px" }}>({counts?.due})</span>}
                </Button>
                <Button variant="outlined" className="Tabbutton Fonts" style={{ color: this.state.overdueText, backgroundColor: this.state.overduebackground, fontWeight: this.state.overdueWeight }} onClick={this.overduecustomerlist.bind(this)}>
                  {t('Loans.over')}{counts?.overdue > 0 && <span style={{ marginLeft: "5px" }}>({counts?.overdue})</span>}
                </Button>
              </Typography>
            </div>
          </section>
          <section className='CustomerHeaderfilter'>
            <div className="filterBarWrapper">
              <div className="filterBar">
                <div className="filterItem" style={{ display: this.state.collectionseq }}>
                  <span className="filterLabel Fonts">{t('Loans.Collseq')}:</span>
                  <div className="filterControl">
                    <InputLabel id="demo-controlled-open-select-label" style={{ position: "absolute", marginTop: "10px", fontSize: "0.875rem", display: this.state.label }}>{t('Loans.all')}</InputLabel>
                    <Select labelid="demo-controlled-open-select-label" value={this.state.sequence || ""} onChange={this.CollectseqChange}>
                      <MenuItem value={null} selected className="Fonts">{t('Loans.all')}</MenuItem>
                      <MenuItem value="Monthly" className="Fonts">{t('Dashboard.Months')}</MenuItem>
                      <MenuItem value="Daily" className="Fonts">{t('Dashboard.Days')}</MenuItem>
                      {getSecureItem("loggedinUserCompany") == 2891 && <MenuItem value="Ten_Daily" className="Fonts">Ten_Daily</MenuItem>}
                      <MenuItem value="Weekly" className="Fonts">{t('Loans.weeks')}</MenuItem>
                      <MenuItem value="BiWeekly" className="Fonts">Bi-Weekly</MenuItem>
                    </Select>
                  </div>
                </div>
                <div className="filterItem">
                  <span className="filterLabel Fonts">Collection Agent:</span>
                  <div className="filterControl">
                    <Select labelid="demo-controlled-open-select-label" value={this.state.cAgentId || ""} onChange={this.CollectionAgentChange}>
                      <MenuItem value={"All"} selected className="Fonts">All</MenuItem>
                      {this.state.cAgentDatas?.map((data, index) => (
                        <MenuItem key={index} value={data.userId} className="Fonts">{data.firstName + " " + data.lastName}</MenuItem>
                      ))}
                    </Select>
                  </div>
                </div>
                <div className="filterItem">
                  <CollectionFiltersButton
                    loanTypes={this.state.LaonType}
                    branches={this.state.branches}
                    action={this.Filter}
                    onDateChange={this.save}
                  />
                </div>
                <div className="filterItem customerSortWrapper">
                  <button className="customerSortButton">Sort By ▸</button>
                  <ul className="customerSortMenu">
                    <li className="customerSortItem hasCustomerSubmenu">
                      Due Date
                      <ul className="customerSortSubmenu">
                        <li onClick={() => this.updateSort("dueDate", "ASC")}>Ascending</li>
                        <li onClick={() => this.updateSort("dueDate", "DESC")}>Descending</li>
                      </ul>
                    </li>
                    <li className="customerSortItem hasCustomerSubmenu">
                      Customer ID
                      <ul className="customerSortSubmenu">
                        <li onClick={() => this.updateSort("cust_id", "ASC")}>Ascending</li>
                        <li onClick={() => this.updateSort("cust_id", "DESC")}>Descending</li>
                      </ul>
                    </li>
                    <li className="customerSortItem hasCustomerSubmenu">
                      Name
                      <ul className="customerSortSubmenu">
                        <li onClick={() => this.updateSort("name", "ASC")}>Ascending</li>
                        <li onClick={() => this.updateSort("name", "DESC")}>Descending</li>
                      </ul>
                    </li>
                  </ul>
                </div>
                {userPermissions?.addLoan && (
                  <div className="filterItem ButtonDiv">
                    <Button className="Fonts btnbackgroundcolor adduserbutton" style={{ color: "#fff", textTransform: "capitalize", fontSize: "0.875rem" }} onClick={this.addLoanImport.bind(this)}>
                      <img src={plusicon} alt="plusicon" className="plusiconButton" />
                      {"Import Loans"}
                    </Button>
                  </div>
                )}
                {userPermissions?.addLoan && (
                  <div className="filterItem ButtonDiv">
                    <Button className="Fonts btnbackgroundcolor adduserbutton" style={{ color: "#fff", textTransform: "capitalize", fontSize: "0.875rem" }} onClick={this.addcustomer.bind(this)}>
                      <img src={plusicon} alt="plusicon" className="plusiconButton" />
                      {t('Loans.buttn')}
                    </Button>
                  </div>
                )}
                <div className="filterItem imagediv">
                  <img src={cardviewgreen} alt="cardtype" style={{ display: this.state.cardgreen }} className="cardtypeicon" />
                  <img src={cardtype} alt="cardtype" style={{ display: this.state.cardd }} className="cardtypeicon" onClick={this.CardType.bind(this, "card")} />
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  }
}
export default withNamespaces()(withRouter(CustomerHeader));
